import React from 'react'
import "./Navbar.css"
import { Navbar, Nav } from 'react-bootstrap'
import Home from '../Home/Home'
import logoblue from "../../Assets/Mylogo.png";
import logo from "../../Assets/Mylogoyellow.png";

function Navbars() {
    return (
        <div className='main-image'>
            <Navbar collapseOnSelect expand="lg" variant="dark">

                <Navbar.Brand href="#home" className=' ps-md-4'> 
                    
                  <img src={logo} className="logobrand" alt="logo" />

                    <div className='arbitech-box'>Web Development & Digital Services Company</div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">

                    </Nav>
                    <Nav className="pe-md-5">
                        <Nav.Link className='nav-text' href="#Experience">Experience</Nav.Link>
                        <Nav.Link className='nav-text' href="#project">Our Projects</Nav.Link>
                        {/* <Nav.Link className='nav-text pe-2' href="#feedback">FeedBack</Nav.Link> */}
                        <Nav.Link className='nav-text' href="#contact">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>

            </Navbar>
            <Home />
        </div>
    )
}

export default Navbars